import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useContext } from 'react';
import { get } from 'lodash';
import CloseXsmall from '@elliemae/ds-icons/CloseXsmall';
import DSButton from '@elliemae/ds-button';
import { DropDownContext } from '../context.js';

var ClearIndicator = function ClearIndicator(props) {
  var getStyles = props.getStyles,
      _props$innerProps = props.innerProps,
      ref = _props$innerProps.ref,
      restInnerProps = _objectWithoutProperties(_props$innerProps, ["ref"]),
      innerRef = props.innerRef;

  var c = useContext(DropDownContext);
  return /*#__PURE__*/React.createElement("div", _extends({}, restInnerProps, {
    ref: ref,
    "aria-hidden": "false",
    style: getStyles('clearIndicator', props)
  }), /*#__PURE__*/React.createElement(DSButton, _extends({}, props, {
    "aria-label": "clear-indicator",
    buttonType: "text",
    tabOrder: "2",
    className: "clear-indicator",
    icon: /*#__PURE__*/React.createElement(CloseXsmall, {
      size: "m"
    }),
    innerRef: innerRef,
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
        props.clearValue();
        var select = get(c, 'select.current');
        if (select && select.focus) select.focus();
      }

      if (props.onKeyDown) props.onKeyDown(e);
    }
  })));
};

export default ClearIndicator;
//# sourceMappingURL=ClearIndicator.js.map
